
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Box, Package } from "lucide-react";

export const getCategoryColumns = () => [
  {
    key: "name",
    label: "Product Name",
  },
  {
    key: "description",
    label: "Description",
    render: (row: any) => row.description || "N/A"
  },
  {
    key: "is_bundle",
    label: "Is bundle",
    render: (row: any) => {
      const isBundle = row.is_bundle;
      
      return (
        <div className="flex items-center">
          {isBundle ? (
            <Badge variant="outline" className="flex items-center gap-1 bg-blue-50">
              <Box className="h-3 w-3" />
              <span>Bundle</span>
            </Badge>
          ) : (
            <Badge variant="outline" className="flex items-center gap-1 bg-green-50">
              <Package className="h-3 w-3" />
              <span>Single</span>
            </Badge>
          )}
        </div>
      );
    }
  },
  {
    key: "factories",
    label: "Factories",
    render: (row: any) => {
      const factories = Array.isArray(row.factories) ? row.factories : [];
      
      if (factories.length === 0) {
        return <span className="text-muted-foreground">None</span>;
      }
      
      return (
        <div className="flex flex-wrap gap-1">
          {factories.slice(0, 3).map((factory: string, index: number) => (
            <Badge key={index} variant="outline">{factory}</Badge>
          ))}
          {factories.length > 3 && (
            <Badge variant="secondary">+{factories.length - 3}</Badge>
          )}
        </div>
      );
    }
  }
];
